import React from 'react'
import { Grid, GridColumn, Header } from 'semantic-ui-react'
import { Loader } from 'shared/components/Loader'

export const DemoAccountLoader: React.FC = () => {
  return (
    <Grid className="h-screen !m-0 bg-white" columns={1}>
      <GridColumn verticalAlign="middle" textAlign="center">
        <div>
          <Header as={'h2'}>Launching your demo workspace... 🚀</Header>
          <Loader withContainer containerHeight={40} />
        </div>
      </GridColumn>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/organisms/DemoAccountLoader/index.tsx